import { countTotalAllDivs } from "../helpers/countTotal.js";
import * as loadInventory from '../helpers/loadInventory.js';
import {toFixed} from '../global.js';
import dayjs from 'dayjs'
import DataTable from 'datatables.net-dt';
DataTable.ext.errMode = 'none';
import { swiper_update_height} from "../sliders/sliders.js";
import { getLanguageUrlPrefix } from "../helpers/translations.js";

(async function ($) {


    //items clicks
    $('body').on('click', '.block-tabs-wrap>.swiper>.swiper-wrapper>.swiper-slide.swiper-slide-active .pay__item:not(.my__item)', function (e) {
        //buy tab
        if ($('.block-tabs-wrap>.swiper>.swiper-wrapper>.swiper-slide.swiper-slide-active').find('#js__buy_up').length) {
            //if item has class "my__item" dont move it to top
            if ($(this).hasClass('my__item')) {
                return;
            }
            let top_div = $('#js__buy_up');
            let inventory_div = $('#js__buy')
            if ($(this).parents('#js__buy').length) {
                //in inventory click
                $(this).find('input.item_checkbox_js').prop('checked', true);
                top_div.append($(this));
                countTotalAllDivs();
            } else {
                //in buy div click
                $(this).find('input.item_checkbox_js').prop('checked', false);
                inventory_div.prepend($(this));
                countTotalAllDivs();
            }
        }
        swiper_update_height();
    });

    $('body').on('input', 'input.js_market_price_and_commission', function (e) {
        let price = parseFloat($(this).val());
        let commission = parseFloat($(this).data('market-commission-cof'));
        let comission_amount = price * commission;
        if (comission_amount < 0.01) {
            comission_amount = 0.01;
        }
        let $item_div = $(this).parents('.block__item');
        $item_div.find('.js_market_commission').text(toFixed(comission_amount, 2));
    });




    let deposit_svg = `<svg viewBox="0 0 13 13" width="13" height="13" fill="#c8c8c8" class="icon c-green item-svg" data-img="images/svg/deposit.svg">
                            <path d="M807.345,801.905c1.321,1.4,3.235,4.091,4.084,4.1a1.943,1.943,0,0,0,1.1-.853l2.1-2.162c0.3-.313.625-0.691,0.938-1.08,0.833-.985.318-1.875-0.386-1.843a1.57,1.57,0,0,0-1.159.8c-0.571.588-1.155,1.16-1.711,1.763a2.96,2.96,0,0,1-.773.8,3.66,3.66,0,0,1-1.049-1.023,14.052,14.052,0,0,0-2.373-2.332C807.093,799.7,806.663,801.154,807.345,801.905ZM814,807a2,2,0,0,1,0,4h-5a2,2,0,0,1,0-4s-0.589-2-1-2h-0.5a2.5,2.5,0,0,0-2.5,2.5v3a2.5,2.5,0,0,0,2.5,2.5h8a2.5,2.5,0,0,0,2.5-2.5v-3a2.5,2.5,0,0,0-2.5-2.5h-0.483C814.725,805,814,807,814,807Z" transform="translate(-805 -800)"></path>
                        </svg>`;
    let withdraw_svg = `<svg viewBox="0 0 13 13" width="13" height="13" fill="#c8c8c8" class="icon c-red item-svg" data-img="images/svg/withdraw.svg">
                                <path d="M932.655,805.1c-1.322-1.4-3.235-4.091-4.084-4.1a1.943,1.943,0,0,0-1.1.853q-1.048,1.082-2.1,2.161c-0.3.314-.625,0.692-0.938,1.081-0.833.985-.319,1.875,0.386,1.843a1.57,1.57,0,0,0,1.159-.8c0.571-.588,1.155-1.16,1.711-1.764a2.99,2.99,0,0,1,.773-0.8,3.676,3.676,0,0,1,1.049,1.024,14.129,14.129,0,0,0,2.373,2.332C932.907,807.3,933.337,805.846,932.655,805.1ZM935,808.5v3a2.5,2.5,0,0,1-2.5,2.5h-8a2.5,2.5,0,0,1-2.5-2.5v-3c0-1.381,2,.395,2,1.5a2,2,0,0,0,2,2h5a2,2,0,0,0,2-2C933,808.9,935,807.119,935,808.5Z" transform="translate(-922 -801)"></path>
                            </svg>`;

    let langPrefix = getLanguageUrlPrefix();
    $(document).on('preInit.dt', function (e, settings) {
        $('.dt-search').parent('.dt-layout-cell').parent('.dt-layout-row').addClass('search-row');
        $('.dt-paging').parent('.dt-layout-cell').parent('.dt-layout-row').addClass('pagination-row').hide();
    });
    let history_table_url = '/engine/function/user_trades_history_loader.php';
    let history_table = new DataTable(`.main [data-action="${history_table_url}"] table`, {
        ajax: history_table_url,
        processing: true,
        drawCallback: function (settings) {
            table_add_dark_light(history_table);
            swiper_update_height();
        },
        language: {
            url: `/template/js/lib/datatables/${langPrefix}.json`
        },
        serverSide: true,
        searching: false,
        ordering:  false,
        columns: [
            {
                data: 'show_type',
                className: 'show-type',
                orderable: false,
                render: function (data, type, row) {
                    return data == 'Input' ? deposit_svg : withdraw_svg;
                }
            },
            { data: 'id' },
            {
                data: 'price',
                render: function (data, type, row) {
                    return `<span class="${row.status_class}">${data}</span>`;
                }
            },
            {
                data: 'show_status',
                orderable: false,
                render: function (data, type, row) {
                    return `<span class="${row.status_class}">${data}</span>`;
                }
            },
            {
                data: 'end_timestamp',
                render: function (data, type, row) {
                    return dayjs.unix(data).format("YYYY.MM.DD HH:mm");
                }
            },
            {
                data: 'protection_code',
                orderable: false,
                render: function (data, type, row) {
                    return `<span>${data}</span>`;
                }
            },
            {
                data: null,
                orderable: false,
                render: function (data, type, row) {
                    return `<img src="${row.game_icon}" alt="${row.game_title}" class="icon">
                    <span>${row.game_title}</span>`;
                }
            },
            {
                data: null,
                orderable: false,
                render: function (data, type, row) {
                    return `<div class="toggle-tr-details">
                                <span class="toggle-arrow min absolute"></span>
                            </div>`;
                }
            }
        ],
        order: [],
        "createdRow": function (row, data, dataIndex) {
            $(row).addClass(`js-toggle-tr toggle`);
            $(row).attr('data-toggle', data.id);
        },
        "initComplete": function (settings, json) {
            $(`[data-action="${history_table_url}"]`).find('.pagination-row').show();
            swiper_update_height();
        }

    });


    // Formatting function for row details - modify as you need
    function format(d) {
        // `d` is the original data object for the row
        if (!d.details_hide) {
            return 'error loading details';
        }
        let data = d.details_hide;
        let response = `<div class="toggle-hidden hide">
                            <div class="toggle-tr-hide-wrap">
                                <div class="flex-ac flex-jsb">
                                    <div class="flex-ac">
                        `;
        for (let [key, value] of Object.entries(data)) {
            if (key == 'total_items' || key == 'total_items_value' || key == 'answer_to_user') {
                //skip these values
                continue;
            }
            if (value.title && value.value) {
                response += `<div class="wording">`
                if (value.icon) {
                    response += `<img src="${value.icon}" alt="" class="icon">`;
                }
                response += `  <span>${value.title}: <b>${value.value}</b></span>
                            </div>`;
            }
        }

        //close flex-ac
        response += `</div>`;

        if (data.total_items && data.total_items_value) {
            response += `<div class="wording mr-0">
                            <span>${data.total_items.title}: <b>${data.total_items.value} (${data.total_items_value.value})</b></span>
                        </div>`;
        }

        response += `</div>`;


        //div for answer_to_user
        if (data.answer_to_user && data.answer_to_user.title && data.answer_to_user.value) {
            response += `<div class="flex-ac flex-jsb">
                            <div class="flex-ac">
                                <div class="wording">
                                    <img src="images/svg/shield.svg" alt="" class="icon">
                                    <span>${data.answer_to_user.title}: <b>${data.answer_to_user.value}</b></span>
                                </div>
                            </div>
                        </div>`;
        }


        if (data.items && data.items.value) {
            response += `<div class="table-td-info">`;
            response += data.items.value;
            response += `</div>`;
        }
        response += `</div></div>`;

        return response;
    }

    // Add event listener for opening and closing details
    $('body').on('click', 'tr[data-toggle]:not([data-dt-row])', function (e) {
        let tr = e.target.closest('tr');
        let row = history_table.row(tr);

        if (row.child.isShown()) {
            // This row is already open - close it
            // $('div.slider', row.child()).slideUp(500, function () {
            //     $(tr).find('.show-type').attr('rowspan', '1');
            //     row.child.hide();
            // } );
            setTimeout(() => {
                $(tr).find('.show-type').attr('rowspan', '1');
                row.child.hide();
            }, 500);

        }
        else {
            // Open this row
            $(tr).find('.show-type').attr('rowspan', '2');
            row.child(format(row.data()), `js-toggle--appeared-tr js-toggle-tr toggle-tr-hide toggle-hidden hide ${$(tr).hasClass('dark') ? 'dark' : 'light'}`).show();
            $(row.child()).attr('data-toggle', row.data().id);
            //$('div.slider', row.child()).slideDown(500);
        }
    });




    function table_add_dark_light(datatable) {
        let trs = datatable.rows(':not(js-toggle--appeared-tr)', {
            search: 'applied',
            order: 'current'
        }).nodes();

        $(trs).each(function (i, tr) {
            $(tr).removeClass('dark light');
            $(tr).addClass(i % 2 ? 'light' : 'dark');
        });
    }
})($);


// $(function () {

//     $('.index-news-block__hide').on('click', function () {
//         $(this).parents('.js_user_trades_info_sell').find('.index-news-block__message').toggle();
//         $(this).toggleClass('active');
//     });


//     //history open details
//     $('.pay__history').on('click', '.details__tr_js', function () {
//         var $arrow = $(this).find('.details__arrow');
//         var link = $arrow.attr('data-link');
//         $arrow.toggleClass('details__arrow-on');
//         $('#details_' + link).toggle();
//         $('#trade_type_arrow_' + link).toggleClass('details-on');
//     });

//     //sell input change
//     $('.pay__buy_top ').on('keyup paste input change', '.user_item_price_js', function () {
//         set_sell_item_info();
//         $('.pay__buy_top .bet-content__betcoin_money').text(toFixed($(this).val() - $('span.commission_js').html(), 2) + '$').data('betcoin', $(this).val());
//         checkNoCoins();
//     })

//     //item click
//     $('.pay__tabs').on('click', '.game_item', function (e) {
//         if (e.target.tagName != 'INPUT') {
//             return;
//         }
//         if ($(this).parent().hasClass('items_my')) {
//             //move to top

//             //if sell tab
//             if ($(this).parents().hasClass('pay__sell__tabs_content_js')) {
//                 $('.pay__sell__tabs_content_js .items__tabs_middle_js .game_item').each(function (i, element) {
//                     $(element).find('input.item_checkbox_js').click();
//                 });
//                 //var $item_value_div = $(this).find('.item_value');
//             }
//             $(this).find('input.item_checkbox_js').prop('checked', true);
//             $('.items__tabs_middle_js:visible').prepend($(this));
//         } else if ($(this).parent().hasClass('items__tabs_middle_js')) {
//             //move to bottom
//             $(this).find('input.item_checkbox_js').prop('checked', false);
//             $('.items__tabs_bottonm-weapon .items_my:visible').prepend($(this));//надо выбирать в какую вкладку возвращать
//         }

//         //hide/show "Choose item for trading" block if have items
//         if ($('.items__tabs_middle_js:visible .game_item').length == 0) {
//             //console.log('show');
//             $('.items__tabs_middle-betcoin:visible .items__tabs_middle-no_item-bottom').show();
//         } else {
//             //console.log('hide');
//             $('.items__tabs_middle-betcoin:visible .items__tabs_middle-no_item-bottom').hide();
//         }
//         set_sell_item_info(true);
//         calcItems();
//         fix_horisontal_margins('.margin_fix_js','.game_item', 5);;
//     });

//     function set_sell_item_info(new_item = false) {
//         var $item_value_div = $('.pay__buy_top-left div.item_value:visible');
//         if (new_item && $item_value_div.data('price')) {
//             $('.pay__sell .user_item_price_js').val($item_value_div.data('price'));
//         }
//         if (new_item && $('.pay__sell .user_item_price_js').attr('min') && $('.pay__sell .user_item_price_js').attr('min') > $('.pay__sell .user_item_price_js').val()){
//             $('.pay__sell .user_item_price_js').val($('.pay__sell .user_item_price_js').attr('min'));
//         }
//         var $item_price = $('.pay__sell .user_item_price_js').val();
//         if ($item_value_div) {
//             var $commision = $item_value_div.data('selling_items_cof') * $item_price;
//             if ($commision < 0.01) {
//                 $commision = 0.01;
//             }
//             var $avg_price = $item_value_div.data('selling_items_avg') ? $item_value_div.data('selling_items_avg') : 0;
//             var $min_price = $item_value_div.data('selling_items_min_price') ? $item_value_div.data('selling_items_min_price') : 0;
//             var $max_price = $item_value_div.data('selling_items_max_price') ? $item_value_div.data('selling_items_max_price') : 0;
//         } else {
//             var $commision = 0;
//             var $avg_price = 0;
//             var $min_price = 0;
//             var $max_price = 0;
//         }
//         $('.commission_js').text(toFixed($commision, 2));
//         $('.avg_price_js').text($avg_price);
//         $('.min_price_js').text($min_price);
//         $('.max_price_js').text($max_price);
//     }

//     //buy sell history button click
//     $('.pay__tab_title').on('click', function () {
//         // if ($(this).hasClass('checked')) {
//         //     return;
//         // }
//         $('.pay__tab_title').removeClass('pay__tab_title-active');
//         $(this).addClass('pay__tab_title-active');
//         $('.pay__tab_content').hide().removeClass('checked');
//         $('.js_user_trades_info_sell').hide();
//         if ($(this).hasClass('pay__buy__tabs_title_js')) {
//             //buy
//             $('.pay__buy__tabs_content_js').show().addClass('checked');
//             window.history.replaceState('', '', `?buy`);
//         } else if ($(this).hasClass('pay__sell__tabs_title_js')) {
//             //sell
//             $('.pay__sell__tabs_content_js').show().addClass('checked');
//             $('.js_user_trades_info_sell').show();
//             window.history.replaceState('', '', `?sell`);
//         } else if ($(this).hasClass('pay__history__tabs_title_js')) {
//             //history
//             $('.pay__history__tabs_content_js').show().addClass('checked');
//             window.history.replaceState('', '', `?history`);
//         }
//         calcItems();
//     })
//     $('.pay__tab_title-active').click();


//     //load sell items
//     $('.pay__sell__tabs_content_js').on('click', '.button-load-ajax', function () {
//         var contentWrapper = $(this).parents('.items_my');
//         var url = contentWrapper.data('url');
//         contentWrapper.empty();
//         contentWrapper.append(loading_html); // вставляет и показывает анимацию загруки

//         $.ajax({
//             url: url,
//             success: function (result) {
//                 contentWrapper.html(result);
//                 calcItems();
//                 sort_by_price_sell(-1);
//                 fix_horisontal_margins('.margin_fix_js','.game_item', 5);;
//             }
//         });
//     });

//     //game tab click
//     $('.items__tabs_bottom-tabs').on('click', 'div', function () {
//         if ($(this).hasClass('checked')) {
//             return;
//         }
//         //remove_my_items_from_top();
//         var show_container = $(this).data('show_container');
//         $('.pay__sell .items__tabs_bottom-tabs div').removeClass('checked');
//         $(this).addClass('checked');
//         $('.pay__sell .items-tab').removeClass('checked').hide();
//         $(show_container).addClass('checked').show();
//         calcItems();
//     });

//     //sell change price sort
//     $('.items__tabs_bottom').on('click', '.items__tabs_bottom-top-sort', function () {
//         sort_by_price_sell();
//     });
//     //sell change search input
//     $('.items__tabs_bottom').on('keyup', '.search_site_items_input_js', function () {
//         if ($(this).is("#search_site_items_input_buy")){
//             return;
//         }
//         var search_name = $(this).val().toLowerCase();
//         var $items_my = $('.items__tabs_bottonm-weapon .items_my:visible');
//         $items_my.children('.game_item').each(function () {
//             if ($(this).text().toLowerCase().includes(search_name)) {
//                 $(this).show();
//             } else {
//                 $(this).hide();
//             }
//         });
//         calcItems();
//     })
//     function sort_by_price_sell(order) {
//         var $items_my = $('.items__tabs_bottonm-weapon .items_my:visible');
//         var $items_my_item = $items_my.children('.game_item');
//         var $order = $(this).data('order-deposit');
//         // console.log($items_my);
//         // console.log($items_my_item);
//         // console.log($order);
//         if (typeof $order === 'undefined') {
//             $order = -1;
//         }
//         if (typeof order != 'undefined') {
//             $order = order;
//         }

//         $items_my_item.sort(function (a, b) {
//             var an = $(a).find('.item_value').data('price'),
//                 bn = $(b).find('.item_value').data('price');
//             if (!$(a).hasClass('nice_item') && $(b).hasClass('nice_item')) {
//                 return 1;
//             }
//             if (an > bn) {
//                 return 1 * $order;
//             }
//             if (an < bn) {
//                 return -1 * $order;
//             }
//             return 0;
//         });

//         $(this).data('order-deposit', -1 * $order);

//         set_sort_arrows($order);

//         $items_my_item.detach().appendTo($items_my);
//     }
//     //sell change of rarity filter
//     $('.items__tabs_bottom').on('change', '.rarity_filter', function () {
//         var $rarity = $(this).val();
//         var $items_my = $('.items__tabs_bottonm-weapon .items_my:visible');
//         $items_my.children('.game_item').each(function () {
//             if ($(this).find('.item_type').data('rarity') == $rarity || $rarity == 'Rarity All') {
//                 $(this).show();
//             } else {
//                 $(this).hide();
//             }
//         });
//         calcItems();
//     });

//     function calcItems() {
//         // //calc top items
//         var sumPrice = 0;
//         $('.items__tabs_middle_js:visible .game_item:visible').each(function () {
//             sumPrice += parseFloat($(this).find('.item_value').data('price'));
//         });
//         sumPrice = toFixed(sumPrice, 2);
//         //if manually changed in input
//         if (sumPrice > 0 && $('.pay__buy_top .user_item_price_js:visible').val() > 0) {
//             sumPrice = toFixed($('.pay__buy_top .user_item_price_js:visible').val(), 2);
//         }
//         $('.bet-content__betcoin_money:visible').text(toFixed(sumPrice - $('span.commission_js').html(), 2) + '$').data('betcoin', sumPrice);
//         $('.user_item_price_js:visible').val(sumPrice);
//         //calc bot items
//         var sumBotPrice = 0;
//         $('.items__tabs_bottonm-weapon:visible .game_item:visible').each(function () {
//             sumBotPrice += parseFloat($(this).find('.item_value').data('price'));
//         });
//         sumBotPrice = toFixed(sumBotPrice, 2);
//         $('.items__tabs_bottom .user_items_price:visible').text(sumBotPrice);
//         checkNoCoins();
//     }

//     function checkNoCoins() {
//         var $betcoin_div = $('.items__tabs_middle-betcoin-bottom:visible');
//         if ($betcoin_div.find('.bet-content__betcoin_money').data('betcoin') > 0.001) {
//             $betcoin_div.removeClass('no-coins');
//         } else {
//             $betcoin_div.addClass('no-coins');
//         }
//     }

//     //buy
//     //click load more items
//     $('body').on('click', '.load_button_more_items_to_buy', function () {
//         $(this).parents('.btn_div').remove();
//         LoadBuyItems();
//     });
//     var buy_sort_by_price = 0;
//     var buy_sort_by_discount = 1;
//     var buy_sort_by_rarity = "Rarity All";
//     var buy_sort_by_game = "Game All";
//     var buy_sort_by_name = "";
//     var buy_sort_item_start_index = 0;
//     var buy_num_of_items_per_load = 200;
//     try {
//         buy_num_of_items_per_load = Math.floor(parseInt($('.items__tabs_bottonm-weapon:visible').width()) /
//             (105 + 5 + 5)//ширина айтема + маржинов
//         ) * 20;
//         // parseInt($('#all_items_to_ex_my_items .game_item.nice_item').css("marginRight").replace('px', '')) +
//         // parseInt($('#all_items_to_ex_my_items .game_item.nice_item').css("marginLeft").replace('px', '')) +
//         // parseInt($('#all_items_to_ex_my_items .game_item.nice_item').width()
//     }
//     catch (e) {
//         console.error(e);
//     }
//     if (!buy_num_of_items_per_load) {
//         buy_num_of_items_per_load = 200;
//     }
//     var is_loading_new_items_buy = false;
//     LoadBuyItems();
//     function LoadBuyItems() {
//         if (is_loading_new_items_buy) {
//             return;
//         }
//         if ($("#search_site_items_input_buy").val().length > minlengthSearch){
//             buy_sort_by_name = $("#search_site_items_input_buy").val();
//         } else {
//             buy_sort_by_name = '';
//         }
//         // console.log('INITIATING loading');
//         // console.log('sort_by_price:', buy_sort_by_price);
//         // console.log('buy_sort_by_discount:', buy_sort_by_discount);
//         // console.log('sort_by_rarity:', buy_sort_by_rarity);
//         // console.log('sort_by_game:', buy_sort_by_game);
//         // console.log('sort_by_name:', buy_sort_by_name);
//         // console.log('sort_item_start_index:', buy_sort_item_start_index);
//         // console.log('num_of_items_per_load:', buy_num_of_items_per_load);
//         var items_in_receiving_tab_inputs = $('.pay__buy_top .items__tabs_middle_js .game_item input.item_checkbox_js');
//         var items_in_receiving_tab_ids = [];
//         for (var index = 0; index < items_in_receiving_tab_inputs.length; index++) {
//             const element = items_in_receiving_tab_inputs[index];
//             items_in_receiving_tab_ids.push($(element).val());
//         }
//         // console.log(items_in_receiving_tab_inputs);
//         // console.log(JSON.stringify(items_in_receiving_tab_ids));
//         if (buy_sort_item_start_index === 0) {
//             $("#all_items_to_buy").empty();
//         }
//         is_loading_new_items_buy = true;
//         // console.log(loading_html);
//         $("#all_items_to_buy").append(loading_html);
//         var post_data = {
//             sort_by_price: buy_sort_by_price,
//             sort_by_discount: buy_sort_by_discount,
//             sort_by_rarity: buy_sort_by_rarity,
//             sort_by_game: buy_sort_by_game,
//             sort_by_name: buy_sort_by_name,
//             sort_item_start_index: buy_sort_item_start_index,
//             num_of_items_per_load: buy_num_of_items_per_load,
//             items_ids_exclude: JSON.stringify(items_in_receiving_tab_ids)
//         };
//         var posting = $.post('https://' + window.location.host + '/engine/function/user_trades_loader.php?buy', post_data);
//         posting.done(function (data) {
//             // console.log('loading done, data length: ', data.length);
//             buy_sort_item_start_index += buy_num_of_items_per_load;
//             is_loading_new_items_buy = false;
//             $("#all_items_to_buy").append(data);
//         });
//         posting.always(function () {
//             $("#all_items_to_buy #loading").remove();
//             $('#clear_load_button_all_items_to_ex_my_items_load').remove();
//             is_loading_new_items_buy = false;
//             // console.log('FINISHED loading');
//             calcItems();
//             fix_horisontal_margins('.margin_fix_js','.game_item', 5);;
//         });
//     };

//     //buy change of rarity filter
//     $('.pay__buy').on('change', '.rarity_filter', function () {
//         buy_sort_by_rarity = $(this).val();
//         buy_sort_by_game = 'Game All';
//         $('.pay__buy .selectbox_game').val(buy_sort_by_game);
//         buy_sort_item_start_index = 0;
//         LoadBuyItems();
//     });
//     //buy change of rarity game
//     $('.pay__buy').on('change', '.selectbox_game', function () {
//         buy_sort_by_game = $(this).val();
//         buy_sort_by_rarity = 'Rarity All';
//         $('.pay__buy .rarity_filter').val(buy_sort_by_rarity);
//         buy_sort_item_start_index = 0;
//         LoadBuyItems();
//     });
//     //buy change of search input
//     var minlengthSearch = 3;
//     $('.pay__buy_bottom').on('keyup', '#search_site_items_input_buy', function () {
//         var value = $(this).val();
//         if (buy_sort_by_name != value && (value.length >= minlengthSearch || value.length == 0)) {
//             buy_sort_by_name = value;
//             buy_sort_item_start_index = 0;
//             LoadBuyItems();
//         }
//     });
//     //buy change price sort
//     $('.pay__buy').on('click', '.items__tabs_bottom-top-sort_price', function () {
//         buy_sort_item_start_index = 0;
//         sort_by_price_buy();
//     });
//     //buy change discount sort
//     $('.pay__buy').on('click', '.items__tabs_bottom-top-sort_discount', function () {
//         buy_sort_item_start_index = 0;
//         sort_by_discount_buy();
//     });
//     function sort_by_price_buy(order) {
//         var $order = $(this).data('order-withdraw');
//         if (typeof $order === 'undefined') {
//             $order = -1;
//         }
//         if (typeof order != 'undefined') {
//             $order = order;
//         }
//         $(this).data('order-withdraw', -1 * $order);
//         buy_sort_by_price = -1 * $order;
//         buy_sort_by_discount = 0;
//         set_sort_arrows($order);
//         set_sort_arrows_discount(0);
//         LoadBuyItems();
//     }

//     function sort_by_discount_buy(order) {
//         var $order = $(this).data('order-withdraw');
//         if (typeof $order === 'undefined') {
//             $order = -1;
//         }
//         if (typeof order != 'undefined') {
//             $order = order;
//         }
//         $(this).data('order-withdraw', -1 * $order);
//         buy_sort_by_price = 0;
//         buy_sort_by_discount = -1 * $order;
//         set_sort_arrows(0);
//         set_sort_arrows_discount($order)
//         LoadBuyItems();
//     }

//     function set_sort_arrows(order) {
//         if (order == 1) {
//             $('.sort_items_by_price_js_up:visible').removeClass('active');
//             $('.sort_items_by_price_js_down:visible').addClass('active');
//         } else if (order == -1) {
//             $('.sort_items_by_price_js_up:visible').addClass('active');
//             $('.sort_items_by_price_js_down:visible').removeClass('active');
//         } else {
//             $('.sort_items_by_price_js_up:visible').removeClass('active');
//             $('.sort_items_by_price_js_down:visible').removeClass('active');
//         }
//     }
//     function set_sort_arrows_discount(order) {
//         if (order == 1) {
//             $('.sort_items_by_discount_js_up:visible').removeClass('active');
//             $('.sort_items_by_discount_js_down:visible').addClass('active');
//         } else if (order == -1) {
//             $('.sort_items_by_discount_js_up:visible').addClass('active');
//             $('.sort_items_by_discount_js_down:visible').removeClass('active');
//         } else {
//             $('.sort_items_by_discount_js_up:visible').removeClass('active');
//             $('.sort_items_by_discount_js_down:visible').removeClass('active');
//         }
//     }

//     $(window).resize(function () {
//         fix_horisontal_margins('.margin_fix_js','.game_item', 5);;
//     });


//     //история
//     //подгрузка данных в истории
//     $('.pay__history__tabs_content_js').on('click', '.button-load-ajax', function () {
//         load_more_history();
//     });

//     let history_page = 0;
//     load_more_history();
//     function load_more_history() {
//         var contentWrapper = $('#history_table_js');
//         let loading_div = $('.pay__history .loading-div');
//         let load_btn=$('.pay__history .button-load-ajax');
//         // console.log(history_page);
//         var url = contentWrapper.data('url') + `?page=${history_page}`;
//         // console.log(url);
//         // console.log(contentWrapper);
//         // console.log(load_btn);
//         load_btn.hide(); // скрывает кнопку
//         loading_div.show();
//         $.ajax({
//             url: url,
//             success: function (result) {
//                 // console.log(1);
//                 // console.log(contentWrapper);
//                 // console.log(result);
//                 if (!result || result.trim() == "NONE") {
//                     loading_div.hide();
//                     load_btn.hide();
//                     return;
//                 }
//                 loading_div.hide();
//                 load_btn.show();
//                 contentWrapper.append(result);
//                 $(window).trigger('resize');
//                 history_page++;
//             }
//         });
//     }
// })